// ============================================================================
// view.pigweighins — shared census plus nonblocking metric projections
// ============================================================================
// The list resource owns required sessions/entries. The pig metric resource is
// deliberately distinct because its per-session RPC failures are nonblocking
// and its requests begin only after the required list has rendered.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'view.pigweighins',
  obligations: Object.freeze([
    Object.freeze({id: 'livestock.weighins.list', owner: 'permanent'}),
    Object.freeze({id: 'pig.weighins.metrics', owner: 'permanent'}),
  ]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
